export default __webpack_public_path__ + "static/media/imatge-carrega-video-intro-mobile.d840bb61.jpg";